import { NgModule } from '@angular/core';
import { SharedModule } from './../../shared/shared.module';
import { HomeComponent } from './home.component';
import { DataFormModule } from "../../shared/data-form.module";
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [HomeComponent],
  imports: [
    SharedModule,
    DataFormModule
  ]
})
export class HomeModule { }
